var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocsIcon = function SvgDocsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 45,
    viewBox: "0 0 64 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7.28043C21.5267 -0.916127 7.90368 2.34732 2.40137 5.00361V40.2924C10.9394 37.2907 22.8928 36.7215 32 42M32 7.28043C36.3639 3.86528 48.2793 -1.37128 61.0295 5.00361V40.2924C57.0451 38.9983 41.6765 35.5831 32 42M32 7.28043V42",
    stroke: "#0C2945",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66211 13.5425C17.2002 11.2622 21.7538 12.4037 26.3075 14.1066",
    stroke: "#0C2945",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66211 20.5035C17.2002 18.2232 21.7538 19.3646 26.3075 21.0676",
    stroke: "#0C2945",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66211 28.4722C17.2002 26.1919 21.7538 27.3334 26.3075 29.0363",
    stroke: "#0C2945",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9062 13.5425C47.3682 11.2622 42.8145 12.4037 38.2609 14.1066",
    stroke: "#0C2945",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9062 20.5035C47.3682 18.2232 42.8145 19.3646 38.2609 21.0676",
    stroke: "#0C2945",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9062 28.4722C47.3682 26.1919 42.8145 27.3334 38.2609 29.0363",
    stroke: "#0C2945",
    strokeWidth: 2.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/docs-icon.9038bb9c.svg";
export { ForwardRef as ReactComponent };